import { getBackVersion } from '../config';
import { QuerySnapshot } from '../models';
import api from './api';

type QueryEndpointResponse = Omit<QuerySnapshot, 'result'> & {
    result: Omit<QuerySnapshot['result'], 'slug'>;
};

const getQuery = (queryId: number): Promise<QuerySnapshot> => {
    return api
        .request<QueryEndpointResponse>({
            method: 'GET',
            url: `${getBackVersion()}/agent/queries/` + queryId,
        })
        .then(query => ({
            ...query,
            result: {
                ...query.result,
                slug: query.querySlug,
            } as QuerySnapshot['result'],
        }));
};

export default { getQuery };
